export const API_PATH_ApiLanePlanningLoadItemGet = '/services/lane-planning/apiLanePlanningLoadItemGet';
